import React, { ReactNode, useMemo } from "react";
import { useLocation } from "react-router-dom";
import { joinClassnames, mapMultiClassnames } from "utils/map-modifier";
import "./index.scss";

export const TableHead: React.FC<TableProps> = (props: TableProps) => {
  return <thead>{props.children}</thead>;
};

export const TableBody: React.FC<TableProps> = (props: TableProps) => {
  return <tbody>{props.children}</tbody>;
};

interface ThProps {
  children: ReactNode;
  modifiers?: (
    | "textRight"
    | "center"
    | "heading"
    | "lightblue"
    | "textBlue"
    | "textBlack"
    | "textGreen-light"
    | "textWhite"
    | "small"
    | "responsive"
    | "bold"
    | "lh-1"
    | "w-100")[];
  colSpan?: number;
  rowSpan?: number;
}
export const Th: React.FC<ThProps> = ({
  modifiers,
  colSpan,
  rowSpan,
  children,
}) => {
  const thClassName = useMemo(
    () => mapMultiClassnames("m-table_th", modifiers),
    [modifiers],
  );
  return (
    <th className={thClassName} colSpan={colSpan} rowSpan={rowSpan}>
      {children}
    </th>
  );
};

interface TrProps {
  modifiers?: ("border" | "primary-dark")[];
  children: ReactNode;
}
export const Tr: React.FC<TrProps> = ({ modifiers, children }) => {
  const tdClassName = useMemo(
    () => mapMultiClassnames("m-table_tr", modifiers),
    [modifiers],
  );
  return <tr className={tdClassName}>{children}</tr>;
};

interface TdProps {
  modifiers?: (
    | "textRight"
    | "center"
    | "heading"
    | "lightblue"
    | "textBlue"
    | "textBlack"
    | "textGreen-light"
    | "textWhite"
    | "small"
    | "responsive"
    | "bold"
    | "middle"
    | "lh-1"
    | "w-100"
    | "w-50"
    | "w-56"
    | "w-150"
    | "pt-4"
    | "pb-4"
    | "p-0"
    | "pl-0"
    | "pr-0"
    | "pt-0"
    | "pb-0"
    | "bl-0"
    | "b-0"
    | "br-0"
    | "bt-0"
    | "bb-0"
    | "bl-0"
    | "center-flex")[];
  children: ReactNode;
  colSpan?: number;
  rowSpan?: number;
  className?: string;
  style?: { [key: string]: string | number };
}
export const Td: React.FC<TdProps> = ({
  modifiers,
  className,
  style,
  colSpan,
  rowSpan,
  children,
}) => {
  const tdClassName = useMemo(
    () =>
      joinClassnames(mapMultiClassnames("m-table_td", modifiers), className),
    [className, modifiers],
  );
  return (
    <td
      style={style}
      className={tdClassName}
      colSpan={colSpan}
      rowSpan={rowSpan}
    >
      {children}
    </td>
  );
};

interface TableProps {
  children?: ReactNode;
  horizontal?: boolean;
  title?: string;
  modifiers?: string[];
}

const Table: React.FC<TableProps> = ({ modifiers, title, children }) => {
  const location = useLocation();

  const owlClass = useMemo(
    () =>
      location && location.pathname.includes("/so-sanh")
        ? "m-table"
        : location.pathname.includes("/gio-hang") ||
          location.pathname.includes("/thanh-toan") ||
          location.pathname.includes("/ket-qua-tim-kiem-don-hang")
        ? "m-table m-table-cart-responsive"
        : "m-table m-table-responsive",
    [location],
  );

  const tableClassName = useMemo(
    () => mapMultiClassnames(owlClass, modifiers),
    [owlClass, modifiers],
  );

  return (
    <div className={tableClassName}>
      <table>
        {title && <caption>{title}</caption>}
        {children}
      </table>
    </div>
  );
};

export default Table;
